import { useEffect, useMemo } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import { useNavigate } from "react-router-dom";
import { STATUS } from "@/lib/status";
import { fmtMW } from "@/lib/format";

const icons = {};
const iconFor = (status) => {
  if (!icons[status]) {
    icons[status] = L.divIcon({
      className: "plant-marker",
      html: `<div class="plant-marker-dot plant-marker-${status}"></div>`,
      iconSize: [14, 14],
      iconAnchor: [7, 7],
      popupAnchor: [0, -8],
    });
  }
  return icons[status];
};

const FitBounds = ({ points }) => {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) {
      map.setView(points[0], 9);
      return;
    }
    map.fitBounds(L.latLngBounds(points), { padding: [28, 28], maxZoom: 10 });
  }, [map, points]);
  return null;
};

export const PlantMap = ({ plants = [], height = 320, className, interactive = true, zoomControl = true }) => {
  const navigate = useNavigate();
  const points = useMemo(() => plants.filter((p) => p.lat && p.lon).map((p) => [p.lat, p.lon]), [plants]);
  if (!points.length) return null;
  return (
    <div style={{ height }} className={className} data-testid="plant-map">
      <MapContainer center={points[0]} zoom={7} scrollWheelZoom={false} zoomControl={zoomControl} dragging={interactive} style={{ height: "100%", width: "100%" }} attributionControl={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-bidragsytere' />
        <FitBounds points={points} />
        {plants.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lon]} icon={iconFor(p.status || "stopped")} eventHandlers={{ click: () => {} }}>
            <Popup>
              <div className="space-y-1">
                <div className="font-semibold text-[13px]">{p.name}</div>
                <div className="text-muted-foreground text-xs">
                  {p.municipality} · {STATUS[p.status]?.label || p.status}
                </div>
                <div className="metric text-xs">
                  {fmtMW(p.power_mw, 2)} av {fmtMW(p.capacity_mw, 1)}
                </div>
                <button type="button" className="mt-1.5 inline-flex items-center gap-1 text-xs font-semibold text-primary underline-offset-2 hover:underline" onClick={() => navigate(`/kraftverk/${p.id}`)} data-testid={`map-open-plant-${p.id}`}>
                  Åpne kraftverk
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
